import banner from "assets/images/blocksPreview/banner.png";
import bannerFullscreen from "assets/images/blocksPreview/bannerFullscreen.png";
import bigImageTextsLeft from "assets/images/blocksPreview/bigImageTextsLeft.png";
import bigImageTextsRight from "assets/images/blocksPreview/bigImageTextsRight.png";
import fourImages from "assets/images/blocksPreview/fourImages.png";
import gallery from "assets/images/blocksPreview/gallery.png";
import galleryFull from "assets/images/blocksPreview/galleryFull.png";
import oneBigTitleText from "assets/images/blocksPreview/oneBigTitleText.png";
import oneImageCentered from "assets/images/blocksPreview/oneImageCentered.png";
import oneImageFull from "assets/images/blocksPreview/oneImageFull.png";
import oneImageLeftOneTexts from "assets/images/blocksPreview/oneImageLeftOneTexts.png";
import oneImageRightOneTexts from "assets/images/blocksPreview/oneImageRightOneTexts.png";
import oneImageTextCentered from "assets/images/blocksPreview/oneImageTextCentered.png";
import oneImageTextFullBackground from "assets/images/blocksPreview/oneImageTextFullBackground.png";
import oneSmallImageLeftTexts from "assets/images/blocksPreview/oneSmallImageLeftTexts.png";
import oneSmallImageRightTexts from "assets/images/blocksPreview/oneSmallImageRightTexts.png";
import oneText from "assets/images/blocksPreview/oneText.png";
import productDescription from "assets/images/blocksPreview/productDescription.png";
import productHighlight from "assets/images/blocksPreview/productHighlight.png";
import sectionOne from "assets/images/blocksPreview/sectionOne.png";
import sectionOneImageThreeTexts from "assets/images/blocksPreview/sectionOneImageThreeTexts.png";
import sectionOneTitleTwoTexts from "assets/images/blocksPreview/sectionOneTitleTwoTexts.png";
import sectionProductFooter from "assets/images/blocksPreview/sectionProductFooter.png";
import sectionSevenTexts from "assets/images/blocksPreview/sectionSevenTexts.png";
import sectionThreeImagesTwoTexts from "assets/images/blocksPreview/sectionThreeImagesTwoTexts.png";
import sectionThreeParagraphs from "assets/images/blocksPreview/sectionThreeParagraphs.png";
import sectionTitleVerticalSeparator from "assets/images/blocksPreview/sectionTitleVerticalSeparator.png";
import sectionTwo from "assets/images/blocksPreview/sectionTwo.png";
import sectionVideo from "assets/images/blocksPreview/sectionVideo.png";
import sectionVideoCompany from "assets/images/blocksPreview/sectionVideoCompany.png";
import squaredImageTextsLeft from "assets/images/blocksPreview/squaredImageTextsLeft.png";
import squaredImageTextsRight from "assets/images/blocksPreview/squaredImageTextsRight.png";
import threeImages from "assets/images/blocksPreview/threeImages.png";
import titleSeparator from "assets/images/blocksPreview/titleSeparator.png";
import topTitleWithBackground from "assets/images/blocksPreview/topTitleWithBackground.png";
import twoImages from "assets/images/blocksPreview/twoImages.png";
import twoImagesLeftBig from "assets/images/blocksPreview/twoImagesLeftBig.png";
import twoImagesLeftTextsButtons from "assets/images/blocksPreview/twoImagesLeftTextsButtons.png";
import twoImagesRightBig from "assets/images/blocksPreview/twoImagesRightBig.png";
import twoImagesRightTextsButtons from "assets/images/blocksPreview/twoImagesRightTextsButtons.png";
import videoFull from "assets/images/blocksPreview/videoFull.png";

import { BlockEnum } from "types/enums";

type BlockEnumMapType = { [x in BlockEnum]: { img: string; title: string } };

export const blockEnumMap: BlockEnumMapType = {
    [BlockEnum.SectionTwoImagesVertical]: {
        img: twoImages,
        title: "Due immagini",
    },
    [BlockEnum.SectionThreeImagesVertical]: {
        img: threeImages,
        title: "Tre immagini",
    },
    [BlockEnum.SectionFourImagesVertical]: {
        img: fourImages,
        title: "Quattro immagini",
    },
    [BlockEnum.SectionGallery]: {
        img: gallery,
        title: "Galleria",
    },
    [BlockEnum.SectionGalleryFull]: {
        img: galleryFull,
        title: "Galleria fullscreen",
    },
    [BlockEnum.SectionTitleSeparator]: {
        img: titleSeparator,
        title: "Titolo separatore",
    },
    [BlockEnum.SectionTwoImagesRightBig]: {
        img: twoImagesRightBig,
        title: "Due immagini con immagine a destra grande",
    },
    [BlockEnum.SectionTwoImagesLeftBig]: {
        img: twoImagesLeftBig,
        title: "Due immagini con immagine a sinistra grande",
    },
    [BlockEnum.SectionVideoSideLeft]: {
        img: twoImages,
        title: "Video a sinistra con immagine a destra",
    },
    [BlockEnum.SectionVideoSideRight]: {
        img: twoImages,
        title: "Video a destra con immagine a sinistra",
    },
    [BlockEnum.SectionOneTitleTwoTexts]: {
        img: sectionOneTitleTwoTexts,
        title: "Due paragrafi con titolo e sottotitolo",
    },
    [BlockEnum.SectionOneImageCentered]: {
        img: oneImageCentered,
        title: "Immagine centrale",
    },
    [BlockEnum.SectionOneImageFull]: {
        img: oneImageFull,
        title: "Immagine fullscreen",
    },
    [BlockEnum.SectionOneImageRightFiveTexts]: {
        img: bigImageTextsLeft,
        title: "Immagine grande a destra con testo a sinistra",
    },
    [BlockEnum.SectionOneImageLeftFiveTexts]: {
        img: bigImageTextsRight,
        title: "Immagine grande a sinistra con testo a destra",
    },
    [BlockEnum.SectionOne]: {
        img: sectionOne,
        title: "Introduzione Prodotto",
    },
    [BlockEnum.SectionOneTitleTexts]: {
        img: oneText,
        title: "Paragrafo centrale con bottone",
    },
    [BlockEnum.SectionOneImageTextCentered]: {
        img: oneImageTextCentered,
        title: "Immagine con testo sopra e bottone sotto",
    },
    [BlockEnum.SectionOneImageTextBackgroundCentered]: {
        img: banner,
        title: "Banner bordato con immagine testo e bottone",
    },
    [BlockEnum.SectionOneImageTextBackground]: {
        img: bannerFullscreen,
        title: "Banner largo con immagine testo e bottone",
    },
    [BlockEnum.SectionOneSmallImageRightText]: {
        img: oneSmallImageRightTexts,
        title: "Immagine piccola a destra con testo a sinistra",
    },
    [BlockEnum.SectionOneSmallImageLeftText]: {
        img: oneSmallImageLeftTexts,
        title: "Immagine piccola a sinistra con testo a destra",
    },
    [BlockEnum.SectionTwo]: {
        img: sectionTwo,
        title: "Due immagini verticali con background",
    },
    [BlockEnum.SectionTextOnLeftBackground]: {
        img: squaredImageTextsLeft,
        title: "Immagine quadrata con testo a sinistra",
    },
    [BlockEnum.SectionTextOnRightBackground]: {
        img: squaredImageTextsRight,
        title: "Immagine quadrata con testo a destra",
    },
    [BlockEnum.SectionVideo]: {
        img: sectionVideo,
        title: "Video",
    },
    [BlockEnum.SectionTitleHomePage]: {
        img: oneBigTitleText,
        title: "Titolo homepage",
    },
    [BlockEnum.SectionTitleVerticalSeparator]: {
        img: sectionTitleVerticalSeparator,
        title: "Titolo separatore verticale",
    },
    [BlockEnum.SectionThreeImagesTwoTexts]: {
        img: sectionThreeImagesTwoTexts,
        title: "SDM introduzione",
    },
    [BlockEnum.SectionOneImageThreeTexts]: {
        img: sectionOneImageThreeTexts,
        title: "Virtual tour",
    },
    [BlockEnum.SectionSevenTexts]: {
        img: sectionSevenTexts,
        title: "Due paragrafi disallineati con titolo e sottotitolo",
    },
    [BlockEnum.SectionVideoCompany]: {
        img: sectionVideoCompany,
        title: "Video con anteprima",
    },
    [BlockEnum.SectionThreeParagraphs]: {
        img: sectionThreeParagraphs,
        title: "Tre paragrafi",
    },
    [BlockEnum.SectionProductFooter]: {
        img: sectionProductFooter,
        title: "Tre paragrafi con immagini e bottoni",
    },
    [BlockEnum.SectionTitleSubtitleButton]: {
        img: "",
        title: "Titolo, sottotitolo, bottone e background",
    },
    [BlockEnum.SectionTitleButtonWithFourPaper]: {
        img: "",
        title: "Titolo con bottone e 4 paper numerati",
    },
    [BlockEnum.SectionPaperWithTitleButtonAndRightImage]: {
        img: "",
        title: "Paper con Titolo, bottone e immagine a destra",
    },
    [BlockEnum.SectionTitleRightTextsButtonsOnBackground]: {
        img: "",
        title: "Titolo con testi e bottone a destra su background",
    },
    [BlockEnum.SectionTitleWithFiveImages]: {
        img: "",
        title: "Titolo con cinque immagini",
    },
    [BlockEnum.SectionTopTitleWithBackground]: {
        img: topTitleWithBackground,
        title: "Titolo con background",
    },
    [BlockEnum.SectionTitleWithRightTextsAndButton]: {
        img: "",
        title: "Titolo con testo e bottone a destra",
    },
    [BlockEnum.SectionTextsWithButtonAndRightImage]: {
        img: "",
        title: "Testo con bottone e immagine a destra",
    },
    [BlockEnum.SectionProductDescription]: {
        img: productDescription,
        title: "Blocco testo - centrato",
    },
    [BlockEnum.SectionOneImageTextFullBackground]: {
        img: oneImageTextFullBackground,
        title: "Banner fullscreen con titolo e bottone",
    },
    [BlockEnum.SectionTwoImagesRightTextsButtons]: {
        img: twoImagesRightTextsButtons,
        title: "Due immagini a destra con testo e bottoni",
    },
    [BlockEnum.SectionTwoImagesLeftTextsButtons]: {
        img: twoImagesLeftTextsButtons,
        title: "Due immagini a sinistra con testo e bottoni",
    },
    [BlockEnum.SectionOneImageRightOneTexts]: {
        img: oneImageRightOneTexts,
        title: "Immagine a destra con titolo",
    },
    [BlockEnum.SectionOneImageLeftOneTexts]: {
        img: oneImageLeftOneTexts,
        title: "Immagine a sinistra con titolo",
    },
    [BlockEnum.SectionTitleSubtitleParagraph]: {
        img: "",
        title: "Titolo con sottotitolo e paragrafo",
    },
    [BlockEnum.SectionVideoFull]: {
        img: videoFull,
        title: "Video fullscreen",
    },
    [BlockEnum.SectionProductHighlight]: {
        img: productHighlight,
        title: "Highlights prodotti",
    },
};
